import { GetServerSidePropsContext } from 'next';
import { authToken } from 'src/app/auth/cookies';
import { getUserSubscriptionInfo } from 'src/api/user/dataUser';

import { AUTH_TOKEN_COOKIE_NAME } from './env';

export enum BeekUserRole {
  user = 'USER',
  creator = 'CREATOR',
}

export enum BeekSessionStatus {
  LoggedOut,
  LoggedIn,
  LoggedInWithSubscription,
}

export const loggedIn = (context: GetServerSidePropsContext): boolean => {
  const {
    req: {
      cookies: { [AUTH_TOKEN_COOKIE_NAME]: authToken },
    },
  } = context;
  return Boolean(authToken);
};

export const loggedInWithCookies = (): boolean => Boolean(authToken());

export const getSessionStatus = async (
  context: GetServerSidePropsContext
): Promise<BeekSessionStatus> => {
  if (loggedIn(context)) {
    const userInfo = await getUserSubscriptionInfo(context);
    const hasSubscription = userInfo?.hasSubscription;
    if (hasSubscription) {
      return BeekSessionStatus.LoggedInWithSubscription;
    }
    return BeekSessionStatus.LoggedIn;
  }
  return BeekSessionStatus.LoggedOut;
};
